// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ripple_Ripple__4aQjt {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 30px;
  height: 30px;
  margin-inline: auto;
}
.Ripple_Ripple__4aQjt div {
  position: absolute;
  opacity: 1;
  border-radius: 50%;
  animation: Ripple_ripple__kLlTd 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.Ripple_Ripple__4aQjt div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes Ripple_ripple__kLlTd {
  0% {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/spinners/ripple/Ripple.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,wEAA0D;AAC5D;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF","sourcesContent":[".Ripple {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 30px;\n  height: 30px;\n  margin-inline: auto;\n}\n.Ripple div {\n  position: absolute;\n  opacity: 1;\n  border-radius: 50%;\n  animation: ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n.Ripple div:nth-child(2) {\n  animation-delay: -0.5s;\n}\n@keyframes ripple {\n  0% {\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n  4.9% {\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n  5% {\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 50px;\n    height: 50px;\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Ripple": `Ripple_Ripple__4aQjt`,
	"ripple": `Ripple_ripple__kLlTd`
};
export default ___CSS_LOADER_EXPORT___;
